import { navLinks } from "@/mocks/comicData";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-background-900 text-background-100">
      {/* CTA banner */}
      <div className="relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20stylized%20manga%20illustration%20of%20open%20comic%20book%20pages%20with%20colorful%20action%20panels%20and%20ink%20speed%20lines%20flowing%20outward%2C%20warm%20red%20and%20amber%20tones%20on%20cream%20paper%2C%20dynamic%20energetic%20composition&width=1600&height=480&seq=cta-banner-2026&orientation=landscape"
          alt="打开虚空漫画网开始阅读"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-900/75 to-background-900/40" />
        <div className="relative mx-auto flex w-full max-w-7xl flex-col items-start justify-between gap-6 px-4 py-16 md:flex-row md:items-center md:px-6 md:py-20">
          <div className="max-w-xl">
            <h2 className="font-heading text-3xl leading-tight text-background-50 md:text-4xl">
              现在就进入虚空漫画网开读
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/80 md:text-base">
              海量连载随时开更，收藏本页锁定最新入口，访问无忧，阅读不停。
            </p>
          </div>
          <a
            href="#entrance"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("entrance");
            }}
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            获取访问入口
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>
      </div>

      {/* Footer main */}
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">虚空漫画网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/70">
              一个海量连载、每日更新的漫画阅读平台。汇集全网热门作品，提供多入口多终端访问，让你随时随地、轻松开读。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="#entrance"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo("entrance");
                }}
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-700 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                aria-label="访问入口"
              >
                <i className="ri-door-open-line" />
              </a>
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo("faq");
                }}
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-700 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                aria-label="常见问题"
              >
                <i className="ri-question-line" />
              </a>
              <a
                href="#category"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo("category");
                }}
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-700 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                aria-label="漫画分类"
              >
                <i className="ri-grid-line" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.id);
                    }}
                    className="text-sm text-background-100/70 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">联系方式</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-100/70">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <span>service@xukongmhw.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-global-line mt-0.5 text-accent-400" />
                <span>www.xukongmhw.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                <span>客服在线 09:00 – 23:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-background-100/60 sm:flex-row">
          <p>© {new Date().getFullYear()} 虚空漫画网 收藏本页 · 获取最新入口</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-archive-2-line" />
            入口地址如有变更，本页将持续同步更新
          </p>
        </div>
      </div>
    </footer>
  );
}